import { render, staticRenderFns } from "./playVideo.vue?vue&type=template&id=58b7a350&scoped=true&"
import script from "./playVideo.vue?vue&type=script&lang=js&"
export * from "./playVideo.vue?vue&type=script&lang=js&"
import style0 from "./playVideo.vue?vue&type=style&index=0&id=58b7a350&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7a350",
  null
  
)

export default component.exports